import { render, staticRenderFns } from "./IntegralSetting.vue?vue&type=template&id=4df366d3&"
import script from "./IntegralSetting.vue?vue&type=script&lang=js&"
export * from "./IntegralSetting.vue?vue&type=script&lang=js&"
import style0 from "./IntegralSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports